import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'

window.Editor = Editor
window.StarterKit = StarterKit
